import request from '@/router/axios';
const urlPrefix = ''


export function switchLanguage(data) {
  return request({
    url: '/PmsUser/switchLanguage',
    method: 'POST',
    data
  });
}

export function getCloudHomePage(data) {
  return request({
    url: '/homeController/getCloudHomePage',
    method: 'POST',
    data
  });
}

export function getCloudStatisticByMonthInGR(data) {
  return request({
    url: '/homeController/getCloudStatisticByMonthInGR',
    method: 'POST',
    data
  });
}

export function getCloudStatisticByProjectInGR(data) {
  return request({
    url: '/homeController/getCloudStatisticByProjectInGR',
    method: 'POST',
    data
  });
}

export function getCloudStatisticByMonthInBM(data) {
  return request({
    url: '/homeController/getCloudStatisticByMonthInBM',
    method: 'POST',
    data
  });
}

export function getCloudStatisticByProjectInBM(data) {
  return request({
    url: '/homeController/getCloudStatisticByProjectInBM',
    method: 'POST',
    data
  });
}

export function queryUserHelpStatus(data) {
  return request({
    url: '/homeController/queryUserHelpStatus',
    method: 'POST',
    data
  });
}

export function createUserHelpStatus(data) {
  return request({
    url: '/homeController/createUserHelpStatus',
    method: 'POST',
    data
  });
}



